import React, { FC, ReactNode } from "react";

import { styled } from "@mui/material/styles";

const Root = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingTop: 32,
  paddingBottom: 32,
}));

interface IgPageContentProps {
  children: ReactNode;
  maxWidth?: string;
}

/**
 * @see HTMLDivElement
 */
export const IgPageContent: FC<IgPageContentProps> = (props) => {
  const { children, maxWidth, ...rest } = props;
  return (
    <Root
      id={"ig-page-content"}
      sx={{
        paddingLeft: window.screen.availWidth > 500 ? "35px" : "15px",
        paddingRight: window.screen.availWidth > 500 ? "35px" : "15px",
        maxWidth: maxWidth ?? "1450px",
      }}
      {...rest}
    >
      <>{children}</>
    </Root>
  );
};
